export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/messagePrimaryIcon.94ed4d13.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};